module.exports = __webpack_public_path__ + "img/05.46ae6364.png";